import React from 'react'
import {Flex, Text} from 'rebass';

export default () => (
  <Flex alignItems='center' mt={3} justifyContent='center' color="#CBCFD4">
   <Text>
    Nikki Jack © {new Date().getFullYear()}, Built with
    {` `}
    <a href="https://www.gatsbyjs.org">Gatsby</a>
    </Text>
  </Flex>
)
